
<div class="d-flex flex-column align-items-center">
    <div class="flex-fill" *ngIf="current!=null && max!=null  ">
        <paf-round-progress-svg [value]="current" [max]="max" [width]="width" [height]="height" [color]="color" [stroke]="stroke" [displayMode]="displayMode"></paf-round-progress-svg>
    </div>
    <label *ngIf="labelCod" class="text-center text-success" [paflabel]="labelCod"></label>
</div>